import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'

export const setSearchByGroups = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_BY_GROUPS, searchByGroups: true })
    dispatch({ type: types.SET_SEARCH_BY_COURSES, searchByCourses: false })
  }
}

export const setSearchByCourses = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_BY_GROUPS, searchByGroups: false })
    dispatch({ type: types.SET_SEARCH_BY_COURSES, searchByCourses: true })
  }
}

export const fetchRoles = () => {
  return (dispatch) => {
    AxiosInstance.get('/roles').then((roles) => {
      if (roles && Array.isArray(roles)) {
        dispatch({ type: types.SET_ROLES_LEARNING_PLAN, roles })
      }
    })
  }
}

export const fetchGroupsByRole = (roles) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/group-roles/${roles.option.id}`).then(
      (groups) => {
        dispatch({ type: types.SET_ROLE_GROUPS, data: groups })
      }
    )
  }
}

export const selectRole = (roles) => {
  return (dispatch) => {
    dispatch({
      type: types.SELECT_ROLE,
      role: roles,
    })

    if (roles) {
      dispatch(fetchGroupsByRole(roles))
    } else {
      dispatch({ type: types.SET_ROLE_GROUPS, data: [] })
    }
  }
}

export const setGroupSearch = (value) => ({
  type: types.SET_GROUP_SEARCH,
  payload: value,
})
